import AccessDenied from '../../../assets/images/access-denied.png';
import '../list/scss/CampaignListPageContainer.scss';
import '../overview/scss/CampaignOverviewPageContainer.scss';
import './scss/CampaignDigitalP2PPersonalData.scss';

type Props = {
  isStranger?: boolean;
}

const CampaignDigitalP2PFail = ({ isStranger }: Props) => {
  const disclaimerText = isStranger ? (
    <>
      <p>
      This option is currently available only for Serbian residents.
      </p>
      <p>
    Please visit Yettel shop to convert your prepaid number to postpaid.
      </p>
    </>
  ) : (
    <>
      <p className="">Trenutno nisi u mogućnosti da nastaviš kupovinu sa prosleđenim podacima.</p>
      <p className="">
        Za više informacija pozovi Call Centar{' '}
        <a href="tel:0639000" className="yettel-link">
          0639000.
        </a>
      </p></>
  );

  return (
    <div className="checkout campaign">
      <div className="ps-2 pe-2">
        <section className="p-4 text-18 yettel-font campaign-overview-content mx-auto">
          <div className="d-flex justify-content-center mt-5 mb-2">
            <img src={AccessDenied} alt="acccess denied" />
          </div>
          <section className="rounded-3">
            <div className="campaign-disclaimer my-2 m-auto">
              {disclaimerText}
            </div>
          </section>
        </section>
      </div>
    </div>
  );
};

export default CampaignDigitalP2PFail;
